// import React, { useState, useEffect } from "react";


// // images
// import galleryImage1 from "../../assets/Gallery/Rectangle12.png"
// import galleryImage2 from "../../assets/Gallery/Rectangle14.png"
// import galleryImage3 from "../../assets/Gallery/Rectangle15.png"
// import galleryImage4 from "../../assets/Gallery/Rectangle16.png"
// import galleryImage5 from "../../assets/Gallery/Rectangle17.png"
// import galleryImage6 from "../../assets/Gallery/Rectangle18.png"



// import buttonarrowactive from "../../assets/Buttonarrow.svg";
// import buttonarrowinactive from "../../assets/Buttoninactive.svg";

// const GallerySection = () => {
//   const [activeImage, setActiveImage] = useState(0);
//   const [fade, setFade] = useState(true);
//   const [hoveredButton, setHoveredButton] = useState(null);

//   const galleryItems = [
//     {
//       id: 1,
//       title: "Hospital Help Desk",
//       image: galleryImage1,
//       alt: "Arambh Rehab help desk area",
//     },
//     {
//       id: 2,
//       title: "Therapy Room",
//       image: galleryImage2,
//       alt: "Therapy session room",
//     },
//     {
//       id: 3,
//       title: "Meditation Garden",
//       image: galleryImage3,
//       alt: "Outdoor meditation space",
//     },
//     {
//       id: 4,
//       title: "Meditation Garden",
//       image: galleryImage4,
//       alt: "Outdoor meditation space",
//     },
//     {
//       id: 5,
//       title: "Meditation Garden",
//       image: galleryImage5,
//       alt: "Outdoor meditation space",
//     },
//     {
//       id: 6,
//       title: "Meditation Garden",
//       image: galleryImage6,
//       alt: "Outdoor meditation space",
//     },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       triggerFade(() => {
//         setActiveImage((prev) =>
//           prev === galleryItems.length - 1 ? 0 : prev + 1
//         );
//       });
//     }, 3000);
//     return () => clearInterval(interval);
//   }, [galleryItems.length]);

//   const triggerFade = (callback) => {
//     setFade(false);
//     setTimeout(() => {
//       callback();
//       setFade(true);
//     }, 300);
//   };

//   const prevImage = () => {
//     triggerFade(() => {
//       setActiveImage((prev) =>
//         prev === 0 ? galleryItems.length - 1 : prev - 1
//       );
//     });
//   };

//   const nextImage = () => {
//     triggerFade(() => {
//       setActiveImage((prev) =>
//         prev === galleryItems.length - 1 ? 0 : prev + 1
//       );
//     });
//   };

//   return (
//     <section className="bg-white py-12 md:py-20 px-6 md:px-12 lg:px-24">
//       <div>
//         {/* Heading & Arrows */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 md:mb-12">
//           <h2 className="font-garamond-subheading text-[#2C3075] mb-8 sm:mb-10 lg:mb-12 text-center sm:text-left">
//             Life at Arambh Rehab
//           </h2>

//           {/* Desktop Arrows */}
//           <div className="hidden md:flex space-x-4">
//             {/* Prev */}
//             <button
//               onClick={prevImage}
//               onMouseEnter={() => setHoveredButton("prev")}
//               onMouseLeave={() => setHoveredButton(null)}
//               className="transition"
//             >
//               <img
//                 src={
//                   hoveredButton === "prev"
//                     ? buttonarrowactive
//                     : buttonarrowinactive
//                 }
//                 alt="Previous"
//                 className="w-8 h-8 transform rotate-180 transition-transform duration-300"
//               />
//             </button>
//             {/* Next */}
//             <button
//               onClick={nextImage}
//               onMouseEnter={() => setHoveredButton("next")}
//               onMouseLeave={() => setHoveredButton(null)}
//               className="transition"
//             >
//               <img
//                 src={
//                   hoveredButton === "next"
//                     ? buttonarrowactive
//                     : buttonarrowinactive
//                 }
//                 alt="Next"
//                 className="w-8 h-8 transition-transform duration-300"
//               />
//             </button>
//           </div>
//         </div>

//         {/* Image Gallery */}
//         <div className="flex flex-col items-center">
//           {/* Main Image with overlay title */}
//           <div
//             className={`w-full rounded-3xl overflow-hidden shadow-xl mb-6 md:mb-8 relative transition-opacity duration-500 ${
//               fade ? "opacity-100" : "opacity-0"
//             }`}
//           >
//             <img
//               src={galleryItems[activeImage].image}
//               alt={galleryItems[activeImage].alt}
//               className="w-full h-auto object-cover"
//               style={{ minHeight: "300px", maxHeight: "600px" }}
//             />

//             {/* Title overlay */}
//             {/* <div className="absolute font-generalsans-subheading bottom-0 left-0 text-white px-4 py-2  ">
//               {galleryItems[activeImage].title}
//             </div> */}
//           </div>

//           {/* Mobile Arrows */}
//           <div className="md:hidden flex justify-center space-x-8 mb-6">
//             {/* Prev */}
//             <button
//               onClick={prevImage}
//               onMouseEnter={() => setHoveredButton("m-prev")}
//               onMouseLeave={() => setHoveredButton(null)}
//               className="transition"
//             >
//               <img
//                 src={
//                   hoveredButton === "m-prev"
//                     ? buttonarrowactive
//                     : buttonarrowinactive
//                 }
//                 alt="Previous"
//                 className="w-8 h-8 transform rotate-180 transition-transform duration-300"
//               />
//             </button>
//             {/* Next */}
//             <button
//               onClick={nextImage}
//               onMouseEnter={() => setHoveredButton("m-next")}
//               onMouseLeave={() => setHoveredButton(null)}
//               className="transition"
//             >
//               <img
//                 src={
//                   hoveredButton === "m-next"
//                     ? buttonarrowactive
//                     : buttonarrowinactive
//                 }
//                 alt="Next"
//                 className="w-8 h-8 transition-transform duration-300"
//               />
//             </button>
//           </div>

//           {/* Dots */}
//           <div className="flex space-x-4">
//             {galleryItems.map((item, index) => (
//               <button
//                 key={item.id}
//                 onClick={() => triggerFade(() => setActiveImage(index))}
//                 className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                   activeImage === index
//                     ? "bg-blue-800 scale-125"
//                     : "bg-gray-300"
//                 }`}
//               ></button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default GallerySection;


import React, { useState, useEffect } from "react";

// images (mobile + desktop versions)
import galleryImage1Mobile from "../../assets/Gallery/Rectangle12mob.png";
import galleryImage1Desktop from "../../assets/Gallery/Rectangle12.png";

import galleryImage2Mobile from "../../assets/Gallery/Rectangle14mob.png";
import galleryImage2Desktop from "../../assets/Gallery/Rectangle14.png";

import galleryImage3Mobile from "../../assets/Gallery/Rectangle15mob.png";
import galleryImage3Desktop from "../../assets/Gallery/Rectangle15.png";

import galleryImage4Mobile from "../../assets/Gallery/Rectangle16mob.png";
import galleryImage4Desktop from "../../assets/Gallery/Rectangle16.png";

import galleryImage5Mobile from "../../assets/Gallery/Rectangle17mob.png";
import galleryImage5Desktop from "../../assets/Gallery/Rectangle17.png";

import galleryImage6Mobile from "../../assets/Gallery/Rectangle18mob.png";
import galleryImage6Desktop from "../../assets/Gallery/Rectangle18.png";

// ... add the rest

import buttonarrowactive from "../../assets/Buttonarrow.svg";
import buttonarrowinactive from "../../assets/Buttoninactive.svg";

const GallerySection = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [fade, setFade] = useState(true);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  // ✅ detect screen size change
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ maintain both mobile + desktop images in data
  const galleryItems = [
    {
      id: 1,
      title: "Hospital Help Desk",
      mobile: galleryImage1Mobile,
      desktop: galleryImage1Desktop,
      alt: "Arambh Rehab help desk area",
    },
    {
      id: 2,
      title: "Therapy Room",
      mobile: galleryImage2Mobile,
      desktop: galleryImage2Desktop,
      alt: "Therapy session room",
    },
    {
      id: 3,
      title: "Meditation Garden",
      mobile: galleryImage3Mobile,
      desktop: galleryImage3Desktop,
      alt: "Outdoor meditation space",
    },
    {
      id: 4,
      title: "Meditation Garden",
      mobile: galleryImage4Mobile,
      desktop: galleryImage4Desktop,
      alt: "Outdoor meditation space",
    },
    {
      id: 5,
      title: "Meditation Garden",
      mobile: galleryImage5Mobile,
      desktop: galleryImage5Desktop,
      alt: "Outdoor meditation space",
    },
    {
      id: 6,
      title: "Meditation Garden",
      mobile: galleryImage6Mobile,
      desktop: galleryImage6Desktop,
      alt: "Outdoor meditation space",
    },
    // ... add all items
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      triggerFade(() => {
        setActiveImage((prev) =>
          prev === galleryItems.length - 1 ? 0 : prev + 1
        );
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [galleryItems.length]);

  const triggerFade = (callback) => {
    setFade(false);
    setTimeout(() => {
      callback();
      setFade(true);
    }, 300);
  };

  const prevImage = () => {
    triggerFade(() => {
      setActiveImage((prev) =>
        prev === 0 ? galleryItems.length - 1 : prev - 1
      );
    });
  };

  const nextImage = () => {
    triggerFade(() => {
      setActiveImage((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    });
  };

  return (
    <section className="bg-white py-12 md:py-20 px-6 md:px-12 lg:px-24">
      <div>
        {/* Heading & Arrows */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 md:mb-12">
          <h2 className="font-garamond-subheading text-[#2C3075] mb-8 sm:mb-10 lg:mb-12 text-center sm:text-left">
            Life at Arambh Rehab
          </h2>

          {/* Desktop Arrows */}
          <div className="hidden md:flex space-x-4">
            <button
              onClick={prevImage}
              onMouseEnter={() => setHoveredButton("prev")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <img
                src={
                  hoveredButton === "prev"
                    ? buttonarrowactive
                    : buttonarrowinactive
                }
                alt="Previous"
                className="w-8 h-8 transform rotate-180 transition-transform duration-300"
              />
            </button>
            <button
              onClick={nextImage}
              onMouseEnter={() => setHoveredButton("next")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <img
                src={
                  hoveredButton === "next"
                    ? buttonarrowactive
                    : buttonarrowinactive
                }
                alt="Next"
                className="w-8 h-8 transition-transform duration-300"
              />
            </button>
          </div>
        </div>

        {/* Image Gallery */}
        <div className="flex flex-col items-center">
          <div
            className={`w-full rounded-3xl overflow-hidden shadow-xl mb-6 md:mb-8 relative transition-opacity duration-500 ${
              fade ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={
                isDesktop
                  ? galleryItems[activeImage].desktop
                  : galleryItems[activeImage].mobile
              }
              alt={galleryItems[activeImage].alt}
              className="w-full h-auto object-cover"
              style={{ minHeight: "300px", maxHeight: "600px" }}
            />
          </div>

          {/* Mobile Arrows */}
          <div className="md:hidden flex justify-center space-x-8 mb-6">
            <button
              onClick={prevImage}
              onMouseEnter={() => setHoveredButton("m-prev")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <img
                src={
                  hoveredButton === "m-prev"
                    ? buttonarrowactive
                    : buttonarrowinactive
                }
                alt="Previous"
                className="w-8 h-8 transform rotate-180 transition-transform duration-300"
              />
            </button>
            <button
              onClick={nextImage}
              onMouseEnter={() => setHoveredButton("m-next")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <img
                src={
                  hoveredButton === "m-next"
                    ? buttonarrowactive
                    : buttonarrowinactive
                }
                alt="Next"
                className="w-8 h-8 transition-transform duration-300"
              />
            </button>
          </div>

          {/* Dots */}
          <div className="flex space-x-4">
            {galleryItems.map((item, index) => (
              <button
                key={item.id}
                onClick={() => triggerFade(() => setActiveImage(index))}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  activeImage === index
                    ? "bg-blue-800 scale-125"
                    : "bg-gray-300"
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
